import React from "react";
import "./App.css";
import Start5 from "./Class 5/Start5";
function App() {
  return (
    <div>
      <Start5 />
    </div>
  );
}

export default App;
